import styled from 'styled-components'
// TODO: Migrate to audur-theme
import { Colors, FontSizePx, FontSizeRem } from '@kvika/audur-theme'
import { Grid } from '@kvika/theme'

type InputProps = {
	width: string
	error?: boolean
	fontFamily?: string
	valid?: boolean
}

type ContainerProps = {
	width: string
}

type LabelProps = {
	fontSize?: string
}

export const StyledLabel = styled.label<LabelProps>`
	display: block;
	color: ${Colors.SilverDark};
	font-size: ${(props) => (props.fontSize ? props.fontSize : FontSizeRem.Body)};
	margin-right: 10px;
`

export const StyledTopContainer = styled.div`
	margin-bottom: ${Grid['4px']};
	display: flex;
	flex: 1;
	line-height: 24px;
`

export const StyledInput = styled.input<InputProps>`
	height: 48px;
	color: ${Colors.Beige};
	border: none;
	border-bottom: 2px solid
		${(props) => {
			let color = Colors.LightGray
			if (props.error) color = Colors.Red
			else if (props.valid) color = Colors.Green
			return color
		}};

	border-radius: 2px;
	outline: none;
	/* font-size needed because browsers default stylesheet overrides the body styles */
	font-size: ${FontSizePx.H2};
	width: ${(props) => props.width};
	background-color: transparent !important;
	font-family: var(--CircularPro), Arial, sans-serif;
	transition: all 0.1s ease;
	::placeholder {
		color: ${Colors.LightGray};
		font-size: ${FontSizePx.H2};
	}
	&:not([disabled]):active,
	&:not([disabled]):focus,
	&:not([disabled]):hover {
		border-bottom: 2px solid ${(props) => (props.error ? Colors.Red : Colors.Beige)};
	}

	/* This rules is to avoid having a background color when autofilling the input */
	&:-webkit-autofill,
	&:-webkit-autofill:focus {
		box-shadow: 0 0 0 30px ${Colors.DarkGray} inset !important;
		-webkit-text-fill-color: ${Colors.Beige} !important;
		caret-color: ${Colors.Beige} !important;
	}
	&[data-autocompleted] {
		background-color: transparent !important;
	}
`

export const StyledContainer = styled.div<ContainerProps>`
	position: relative;
	display: flex;
	flex-direction: column-reverse;
	width: ${(props) => props.width};
	padding: 10px;
	&.keyboard-focused {
		border: solid 2px ${Colors.SilverDark};
		border-radius: 8px;
		padding: 8px !important;
	}
`

export const StyledContainerPhoneSSNCurrency = styled.div<ContainerProps>`
	position: relative;
	display: flex;
	flex-direction: column-reverse;
	width: ${(props) => props.width};
	padding: 10px;

	:has(.keyboard-focused) {
		border: solid 2px ${Colors.SilverDark};
		border-radius: 8px;
		padding: 8px;
	}
	& > div {
		padding: 0;
		&.keyboard-focused {
			border: none;
			padding: 0px !important;
		}
	}
`

export const StyledInfo = styled.span`
	margin-top: ${Grid['8px']};
	margin-bottom: ${Grid['8px']};
	font-size: ${FontSizePx.Body};
	max-height: 40px;
	width: 100%;
	overflow: hidden;
	font-weight: 450;
	padding-left: ${Grid['4px']};
	padding-right: ${Grid['4px']};
	color: ${Colors.Beige};
	display: flex;
	align-items: center;
	gap: 8px;
	svg {
		width: 100%;
		height: 100%;
	}
`

type Props = {
	error?: boolean
}

export const StyledCounter = styled.small<Props>`
	color: ${Colors.LightGray};
	margin-left: auto;
	right: 0;
	position: absolute;
	margin-bottom: ${(props) => (props.error ? '38px' : '11px')};
`
